// Generated by https?://quicktype.io

import { TransferBaseModel } from '../transfer-base.model';

export interface AccountConvert extends TransferBaseModel {
    approved: boolean;
}

export interface Account extends TransferBaseModel {
    entity_type_lookup?: EntityTypeLookup;
    payment_platforms_linked?: any[];
    payment_devices_linked?: any[];
    trading_accounts_linked?: any[];
    contacts_linked?: AccountContactLinked[];
    users_linked?: any[];
    enabled?: boolean;
    agent_number?: string;
    application?: AccountApplication;
    owner_id?: string;
    crm_id?: string;
    crm_url?: string;
    trading_account_limit?: number;
    risk_level_lookup?: string;
    account_type_lookup?: string;
    name?: string;
    status_lookup?: string;
    nominated_contact_role?: string;
    nominated_contact_number?: string;
    nominated_contact_email?: string;
    nominated_contact_name?: string;
    type_of_business_lookup?: string;
    position?: Position;
    ib?: Ib;
    compliance?: AccountCompliance;
    tenant?: string;
    created_date?: Date;
    force_3ds?: boolean;
    partners_enabled?: boolean;
}

export interface AccountCompliance {
    legal_accepted?: boolean;
    legal_accepted_date?: string;
    acknowledge_risks?: boolean;
    acknowledge_risks_date?: Date;
    tax_compliance_place_of_birth_lookup?: string;
    tax_compliance_country_of_tax_residence?: string;
    tax_compliance_identification_number?: string;
    tax_compliance_reason_not_provided_lookup?: string;
    tax_compliance_date_added?: string;
    referral_agreement_accepted?: boolean;
    referral_agreement_accepted_date?: Date;
    referral_remuneration_accepted?: boolean;
    referral_remuneration_accepted_date?: Date;
    privacy_policy_accepted?: boolean;
    privacy_policy_accepted_date?: Date;
    quiz_complete?: boolean;
    country_lookup?: string;
    industry?: string;
    regulated_entity?: number;
    company_number?: string;
    lei_number?: string;
    license_number?: string;
    annual_income?: string;
    regulatory_authority_lookup?: string;
    industry_lookup?: string;
}

export interface Ib {
    redirect_link?: string;
    redirect_link_enabled?: boolean;
    account_purpose?: string;
    approx_trading_funds?: number;
    source_of_dealing_funds_lookup?: string;
    previous_traded_products_lookup?: string;
    trading_experience_lookup?: string;
    cxd?: string;
}

export interface Position {
    total_deposit?: number;
    total_withdraw?: number;
    total_trading_volume?: number;
    min_deposit_limit?: number;
    max_deposit_limit?: number;
}

// Generated by https://quicktype.io

export interface AccountContactLinked {
    id: string;
    is_primary: boolean;
    is_manager: boolean;
    is_accountant: boolean;
    first_name?: string;
    last_name?: string;
}

export enum EntityTypeLookup {
    /**
     * Lead/Demonstrate
     */
    LEAD = 'LEAD',
    /**
     * Personal Individual
     */
    PER_IND = 'PER-IND',
    /**
     * Personal Corporate
     */
    IB_COR = 'IB-COR',
    /**
     * IB Individual
     */
    IB_IND = 'IB-IND',
    /**
     * MAM Individual
     */
    MAM_IND = 'MAM-IND',
    /**
     * MAM Corporate
     */
    MAM_JOIN = 'MAM-JOIN',
    /**
     * Personal Corporate
     */
    PER_COR = 'PER-COR',
    /**
     * Personal Joint
     */
    PER_JOI = 'PER-JOI',
    /**
     * Personal Trust/Superannuation
     */
    PER_TRS = 'PER-TRS'
}

export interface AccountApplication {
    website?: string;
    platform?: string;
    clientele?: string;
    employees?: string;
    skrill_id?: string;
    pricing_type?: string;
    investor_type?: string;
    other_brokers?: string;
    appication_name?: string;
    currency_lookup?: string;
    x_clients_ready?: string;
    number_of_clients?: string;
    stage_name_lookup?: string;
    trading_decisions?: string;
    accounts_introduced?: string;
    application_version?: string;
    crm_id_application_ind?: string;
    regulatory_infractions?: string;
    accepted_privacy_policy?: string;
    delivery_channel_lookup?: string;
    outside_representatives?: string;
    relevant_qualifications?: string;
    application_stage_lookup?: string;
    t_c_acceptance_date_time?: string;
    market_data_consumer_type?: string;
    number_of_active_accounts?: string;
    primary_place_of_business?: string;
    appropriateness_quiz_attempt?: string;
    appropriateness_quiz_response?: string;
    number_of_expected_new_clients?: string;
    fx_cfd_spreadbet_recency_lookup?: string;
    two_trades_per_month_in_last_12?: string;
    relevant_professional_experience?: string;
    accepted_disclosure_documentation?: string;
    shares_bonds_funds_recency_lookup?: string;
    how_do_you_trade_fx_cfds_sb_lookup?: string;
    options_futures_warrants_recency_lookup?: string;
}

export enum ApplicationStageLookup {
    Step1 = '1',
    Step2 = '2',
    Step3 = '3',
    Step4 = '4',
    Step5 = '5',
    COMPLETE = 'CMPL'
}

export enum ApplicationStage {
    Approved = 'APPD',
    ApplicationStarted = 'APST',
    FurtherDocsRequired = 'FDRQ',
    Funded = 'FUND',
    Lost = 'LOST',
    Rejected = 'RJTD',
    ApplicationSubmittedNoId = 'SMNI',
    ApplicationSubmittedWithId = 'SMWI',
    Traded = 'TRAD'
}

export interface AccountAdmin extends TransferBaseModel {
    entity_type_lookup?: EntityTypeLookup;
    first_name?: string;
    last_name?: string;
    email?: string;
    address_country?: string;
    locale?: string;
    password?: string;
    phone_mobile?: string;

    affiliate_id?: string;
    website?: string;
}
